<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/teacherlist' }"
          >老师管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{
          currId ? "编辑老师" : "添加老师"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">基本信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formTeacher" label-width="90px">
              <el-form-item label="老师:">
                <el-input v-model="formTeacher.name"></el-input>
              </el-form-item>
              <el-form-item label="联系方式:" style="margin-left: 300px">
                <el-input v-model="formTeacher.phone"></el-input>
              </el-form-item>
              <br />

              <el-form-item label="职务:">
                <!-- <el-input v-model="formTeacher.office"></el-input> -->
                <el-select
                  v-model="formTeacher.office"
                  clearable
                  style="width: 176px"
                >
                  <el-option
                    v-for="item in officeList"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </Card>
      <Card>
        <div class="panel-box">
          <h3 class="panel-title">其他信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formTeacher" label-width="90px">
              <el-form-item label="备注:">
                <el-input
                  :rows="5"
                  style="width: 800px"
                  v-model="formTeacher.remark"
                  type="textarea"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </Card>
      <el-button
        type="primary"
        style="margin-left: 45%; margin-top: 30px; margin-bottom: 50px"
        @click="confirmSubmit"
        >完成</el-button
      >
      <el-button @click="cancelEdit">取消</el-button>
    </div>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
import { formatDateString, testPhone } from "../commonEdu";
export default {
  name: "addTeacher",
  components: {},
  data() {
    return {
      formTeacher: {
        name: "",
        phone: "",
        office: "",
        remark: "",
      },
      currId: "",
      officeList: [
        {
          value: "馆长",
          label: 1,
        },
        {
          value: "定级老师",
          label: 2,
        },
        {
          value: "班主任",
          label: 3,
        },
        {
          value: "助教",
          label: 4,
        },
        {
          value: "审核老师",
          label: 5,
        },
      ],
    };
  },
  created() {
    if (this.$route.query.id != undefined) {
      this.currId = `${this.$route.query.id}`;
      let params = {
        appId: this.$API.APPID,
        id: this.currId,
      };
      this.eduAxiosPostRequest("/edu/eduAdmin/teacher/list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res).list[0];
            this.formTeacher.name = m.name;
            this.formTeacher.phone = m.phone;
            this.formTeacher.office = m.office;
            this.formTeacher.remark = m.remark;
          }
        }
      );
    }
  },
  watch: {},
  methods: {
    confirmSubmit() {
      if (this.formTeacher.name == "") {
        alert("请填写老师");
        return;
      } else if (this.formTeacher.phone && !testPhone(this.formTeacher.phone)) {
        alert("电话号码格式不正确");
        return;
      } else if (this.formTeacher.office == "") {
        alert("请选择职务");
        return;
      }
      let params = {
        appId: this.$API.APPID,
        name: this.formTeacher.name,
        phone: this.formTeacher.phone,
        office: this.formTeacher.office.toString(),
        remark: this.formTeacher.remark,
      };
      if (this.currId != "") {
        params.id = this.currId;
      }
      this.eduAxiosPostRequest("/edu/eduAdmin/teacher/save", params).then(
        (res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.cancelEdit();
          }
        }
      );
    },
    cancelEdit() {
      this.$router.push({
        name: "teacherlist",
      });
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            // console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// addTeacher.vue?52c8acd9